import React, { useEffect, useState } from "react";

export default function CancelSuccess() {

    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
        const interval = setInterval(() => {
          setSeconds(seconds - 1);
            if (seconds <= 1) {
                 window.location.href = '/';
                clearInterval(interval);
                // Redirect to home page
            }else {
                
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [seconds]);




    return (
      <>    <div className="cancel-success">
            <h1>Order Cancellation Successful</h1>
            <p>Your order has been successfully cancelled.</p>
        
            <p>Redirecting to home in {seconds} seconds...</p>

        </div>
        <style jsx>{`
            .cancel-success {
                text-align: center;
                padding: 50px;
                background-color: #f8f9fa;
                border-radius: 8px;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                min-height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }
            .cancel-success h1 {
                color: #28a745;
                font-size: 1rem;
            }
            .cancel-success p {
                color: #6c757d;
                font-size: 0.9rem;
            }
        `}</style>
        </>
    );
}